import type { Runner } from "@pix/script";

/**
 * Phase 1 MVP のセーブストア — localStorage に runner.getState() を保存。
 * バージョン耐性復元アルゴリズムは Phase 2 で実装。
 */

const keyPrefix = "pix-save";

export interface MinimalSave {
  version: 1;
  timestamp: number;
  gameId: string;
  state: ReturnType<Runner["getState"]>;
}

export function saveRunner(runner: Runner, gameId: string, slot: string = "auto"): void {
  const data: MinimalSave = {
    version: 1,
    timestamp: Date.now(),
    gameId,
    state: runner.getState(),
  };
  localStorage.setItem(`${keyPrefix}:${gameId}:${slot}`, JSON.stringify(data));
}

export function loadSave(gameId: string, slot: string = "auto"): MinimalSave | null {
  const raw = localStorage.getItem(`${keyPrefix}:${gameId}:${slot}`);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as MinimalSave;
  } catch {
    return null;
  }
}

export async function applyLoad(runner: Runner, save: MinimalSave): Promise<void> {
  await runner.setState(save.state);
}

export function listSaves(gameId: string): Array<{ slot: string; data: MinimalSave }> {
  const out: Array<{ slot: string; data: MinimalSave }> = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;
    const prefix = `${keyPrefix}:${gameId}:`;
    if (!key.startsWith(prefix)) continue;
    try {
      const data = JSON.parse(localStorage.getItem(key)!) as MinimalSave;
      out.push({ slot: key.slice(prefix.length), data });
    } catch {
      /* ignore */
    }
  }
  return out;
}
